import React, { useEffect, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import html2pdf from 'html2pdf.js';
import { Link } from "react-router-dom";
import FormatDateString from "../dateFormat";
import AddComment from "./AddComment";
import ModifyComment from "./ModifyComment";
import DeletedCommentQuotation from "./DeleteCommentQuot";
import vAdminformat from '../../adminFormat';
import Swal from "sweetalert2";
import UpdateQuotation from "./QuotationUpdate";
import { useInvoicePrinter } from "../PrintInvoices";
const server_backend = config.API_URL;

const QuotationViews = ({ QuotationID, CloseViewQuotation, onRenderComplete, getQuotations }) => {
    //console.log("Unexpected error, please check")

    const [Quotation, setQuotation] = useState({
        jobs: []

    });
    const [formData, setFormData] = useState({
        to: '',
        cc: ''
    });

    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [onCommentID, setOnCommentID] = useState(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sendEmail, setSendEmail] = useState(false);

    function formatDateString(dateString) {

        const date = new Date(dateString);

        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };

        return date.toLocaleString('en-UK', options);
    }


    useEffect(() => {
        const getCurrentQuot = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/quotations/select?id=${QuotationID}`, headers);
                //console.log("Unexpected error, please check")

                if (response.data.RES_CODE === "00") {
                    console.log("Unexpected error, please check")
                    const data = (response.data.RES_RESULT)
                    setTrackingView(data.trackings);
                    setQuotation(data);
                    setFormData({ ...formData, to: data.email });
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            } finally {
                setLoading(false)
                onRenderComplete && onRenderComplete()
            }
        }
        getCurrentQuot();
    }, []);


    const getCurrentQuot = async () => {
        try {
            const response = await axios.get(`${server_backend}/quotations/select?id=${QuotationID}`, headers);
            //console.log("Unexpected error, please check")

            if (response.data.RES_CODE === "00") {
                //console.log("Unexpected error, please check")

                const data = (response.data.RES_RESULT)
                setTrackingView(data.trackings);
                setQuotation(data);
                setFormData({ ...formData, cc: data.email });
            }

        } catch (error) {
            console.log("Unexpected error, please check")
        } finally {
            onRenderComplete && onRenderComplete()
        }
    }


    const downloadInvoice = () => {
        const element = document.getElementById('invoice-container');

        const options = {
            margin: 0,
            filename: 'invoice.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().set(options).from(element).save();
    };

    const { handlePrint } = useInvoicePrinter('invoice-container');



    const showAddCommentModal = () => {
        setIsComment(true)
    }

    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showModifyCommentModal = () => {
        setIsModifyComment(true)
    }

    const CloseModifyCommentModal = () => {
        setIsModifyComment(false)
    }

    const generateOrder = () => {
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to generate the order?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(`${server_backend}/quotations/order/insert`, {
                        id: QuotationID
                    }, headers);
                    console.log("Unexpected error, please check")
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        getQuotations()
                        CloseViewQuotation()

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An unexpected error has occurred',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log("Unexpected error, please check")
                    Swal.fire({
                        icon: 'error',
                        title: 'An unexpected error has occurred',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }

        })
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    function blobToBinary(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsArrayBuffer(blob); //Read the blob as arraybuffer (binary)
        });
    }

    const sendEmailBk = async () => {
        const element = document.getElementById('invoice-container');

        const options = {
            margin: 0,
            filename: 'invoice.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to send the information via email?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    //Generate the PDF as BLOB

                    const pdfBlob = await html2pdf().set(options).from(element).outputPdf('blob');

                    //Build the formdata

                    const formData2 = new FormData();
                    formData2.append('chunk', pdfBlob, 'invoice.pdf');
                    formData2.append('id', QuotationID); 
                    formData2.append('to', formData.to); 
                    formData2.append('cc', formData.cc); 
                    const uploadConfig = {
                        headers: {
                            'Content-Type': 'multipart/form-data', 

                            'Authorization': headers.headers.Authorization,
                        },
                    };

                    const response = await axios.post(`${server_backend}/quotations/sendmail`, formData2, uploadConfig);

                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Email sent successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        setSendEmail(false);
                    }

                } catch (error) {
                    console.log("Unexpected error, please check")
                }
            }

        })


    };

    return (

        <div className="container-fluid">

            {isUpdating ? (
                <UpdateQuotation onClose={CloseModalUpdate} onQuotationID={QuotationID} getQuotations={getCurrentQuot} />
            ) : (
                <div>
                   {/*  <div className="card-header">
                        <div className="d-flex justify-content-end mt-3 p-2">
                            <div className="flex-grow-1">
                                <div className="hstack text-nowrap gap-2">

                                    <button type="button" className="btn btn-danger" onClick={CloseViewQuotation} data-bs-toggle="tooltip" data-bs-placement="top" title="Go Back">
                                        <i className="ri-arrow-go-back-line"></i>
                                    </button>

                                    <button type="button" className="btn btn-warning" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" onClick={ShowModalUpdate}>
                                        <i className="ri-pencil-fill align-bottom"></i>
                                    </button>

                                    <Link to="/create-quotation" className="btn btn-light" data-bs-toggle="tooltip" data-bs-placement="top" title="New Instant Quote">
                                        <i className="ri-file-add-line"></i>
                                    </Link>

                                </div>
                            </div>

                            <div className="flex-shrink-0">
                                <div className="hstack text-nowrap gap-2">

                                    <button type="button" className="btn btn-success" onClick={generateOrder} data-bs-toggle="tooltip" data-bs-placement="top" title="Generate Order">+ Generate Order
                                    </button>

                                    <button type="button" className="btn btn-success" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" onClick={showAddCommentModal}>
                                        <i className="ri-question-answer-line"></i>
                                    </button>

                                    <Link className="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Print" onClick={handlePrint}>
                                        <i className="ri-printer-line"></i>
                                    </Link>

                                    <Link className="btn btn-info" data-bs-toggle="tooltip" data-bs-placement="top" title="Download" onClick={downloadInvoice}>
                                        <i className="ri-download-2-line"></i>
                                    </Link>

                                    <Link className="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Send Email" onClick={() => setSendEmail(true)}>
                                        <i className="ri-mail-send-line"></i>
                                    </Link>

                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="card">
                                <div id="invoice-container">
                                    <center>
                                        <h5 className="text-muted" style={{ paddingBlock: "5px" }}>INSTANT QUOTE</h5>
                                    </center>
                                    <div className="card-header border-bottom-dashed p-4">
                                        <div className="d-sm-flex">
                                            <div className="flex-grow-1">
                                                <img src="assets/images/dbclogo.jpg" alt="" height="40" />
                                                <div className="col-12">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <div className="mt-sm-5 mt-4">
                                                                <h6 className="text-muted text-uppercase fw-semibold">Address</h6>
                                                                <p className="text-muted mb-1" id="address-details">Design Build Cast Ltd
                                                                    Unit 3.01,</p>
                                                                <p className="text-muted mb-0">The Goldsmiths Centre,</p>
                                                                <p className="text-muted mb-0">42 Britton Street,
                                                                    London EC1M 5AD</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="mt-sm-5 mt-4">
                                                                <h6 className="text-muted text-uppercase fw-semibold">Review Information</h6>
                                                                {Quotation.user_close && (
                                                                    <>
                                                                        <p className="text-muted mb-0 fs-25" >Reviewed by: {Quotation.user_close}</p>
                                                                        <p className="text-muted mb-1" id="address-details">{vAdminformat.FormatDate(Quotation.date_close)}</p>

                                                                        <p className="text-muted mb-0">{Quotation.comment_close}</p>
                                                                    </>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="flex-shrink-0 mt-sm-0 mt-3">
                                                <h6><span className="text-muted fw-normal">Email:</span> <span id="email">enquiries@designbuildcast.co.uk</span></h6>
                                                <h6><span className="text-muted fw-normal">Website:</span> <a href="https://enquiries@designbuildcast.co.uk/" className="link-primary" target="_blank" id="website">designbuildcast.co.uk</a></h6>
                                                <h6 className="mb-0"><span className="text-muted fw-normal">Contact No: </span><span id="contact-no">0207 608 2228
                                                </span></h6>
                                            </div>
                                        </div>
                                    </div>
                                    {/*end card-header*/}
                                    <div className="card-body p-4">
                                        <div className="row g-3">
                                            <div className="col-lg-3 col-6">
                                                <p className="text-muted mb-2 text-uppercase fw-semibold">Instant Quote No</p>
                                                <h5 className="fs-14 mb-0"><span id="invoice-no">{Quotation.quot_ID}</span></h5>
                                            </div>
                                            {/*end col*/}
                                            <div className="col-lg-3 col-6">
                                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                                <h6 className="fs-14 mb-0"><span id="invoice-date">{formatDateString(Quotation.date_created)}</span></h6>
                                            </div>
                                            {/*end col*/}
                                            <div className="col-lg-3 col-6">
                                                <p className="text-muted mb-2 text-uppercase fw-semibold">Status</p>
                                                <span className={`${Quotation.est_ID === 4 ? "badge badge-soft-warning text-uppercase"
                                                    : (
                                                        Quotation.est_ID === 5 ? "badge badge-soft-success text-uppercase"
                                                            : (
                                                                Quotation.est_ID === 6 ? "badge badge-soft-danger text-uppercase" : (
                                                                    Quotation.est_ID === 13 ? "badge badge-label bg-danger" : null
                                                                )
                                                            )
                                                    )} text-uppercase`}>
                                                    {Quotation.status_name}
                                                </span>
                                            </div>
                                            {/*end col*/}
                                            <div className="col-lg-3 col-6">
                                                <p className="text-muted mb-2 text-uppercase fw-semibold">Total Amount</p>
                                                <h5 className="fs-14 mb-0"><span id="total-amount">{vAdminformat.FormatMoney(Quotation.total_summary)}</span></h5>
                                            </div>
                                            {/*end col*/}
                                        </div>
                                        {/*end row*/}
                                    </div>
                                    {/*end card-body*/}
                                    <div className="card-body p-4 border-top border-top-dashed">
                                        <div className="row g-3">
                                            <div className="col-sm-6">
                                                <h6 className="text-muted text-uppercase fw-semibold mb-3">Customer Information</h6>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <p className="text-muted mb-1" id="billing-name">{Quotation.fullname}</p>

                                                        <p className="text-muted mb-1" id="billing-address-line-1">{Quotation.email}</p>
                                                        <p className="text-muted mb-1"><span>Phones: </span><span id="billing-phone-no">{Quotation.phone} {Quotation.phone2 && (
                                                            `/ ${Quotation.phone2}`
                                                        )} </span></p>
                                                        <p className="text-muted mb-1" id="billing-name">Customer ID:  <span > {Quotation.cust_ID}</span></p>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-sm-6">
                                                <h6 className="text-muted text-uppercase fw-semibold mb-3">Customer Address</h6>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>


                                                        <p className="text-muted mb-1" id="billing-address-line-1">{Quotation.address}</p>
                                                        <p className="text-muted mb-1">{Quotation.city}, {Quotation.zipcode}</p>
                                                        <p className="text-muted mb-1">{Quotation.country}</p>
                                                    </div>
                                                )}
                                            </div>

                                            {/*end col*/}


                                        </div>
                                        {/*end row*/}
                                    </div>
                                    {/*end card-body*/}
                                    <div className="card-body p-2">
                                        <div className="table-responsive">
                                            <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                                <thead>
                                                    <tr className="table-active">
                                                        <th scope="col" style={{ width: "50px" }}>#</th>
                                                        <th scope="col">Product/Service Details</th>
                                                        <th scope="col">Material</th>
                                                        <th scope="col">Price</th>
                                                        <th scope="col">Quantity</th>
                                                        <th scope="col">Discount</th>
                                                        <th scope="col" className="text-end">Sub total</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="products-list">
                                                    {Quotation && Quotation.jobs && Quotation.jobs.length > 0 ? (
                                                        Quotation.jobs.map((job, index) => (
                                                            <tr key={index}>
                                                                <th scope="row">{index + 1 < 10 ? `0${index + 1}` : index + 1}</th>
                                                                <td className="text-start">
                                                                    <span className="fw-medium">STL Library</span>
                                                                    <p className="text-muted mb-0">Uploaded file: {job.file_name}</p>
                                                                    {/*  <p className="text-muted mb-0">Dimensions: {job.dimensions}</p> */}
                                                                    {/* <p className="text-muted mb-0">Volume: {job.volume} cm³ / Area: {job.area}</p> */}
                                                                    <p className="text-muted mb-0">Weight: {job.weight}</p>
                                                                    <p className="text-muted mb-0">Comment: {job.comment}</p>
                                                                </td>
                                                                <td> {job.materials_name}</td>
                                                                <td>{vAdminformat.FormatMoney(job.price)}</td>
                                                                <td>{job.qty}</td>
                                                                <td>{vAdminformat.FormatMoney(job.discount)}</td>
                                                                <td className="text-end">{vAdminformat.FormatMoney(job.subtotal)}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5"></td>
                                                        </tr>
                                                    )}

                                                    {Quotation && Quotation.moulds && Quotation.moulds.length > 0 ? (
                                                        Quotation.moulds.map((job, index) => (
                                                            <tr key={index}>
                                                                <th scope="row">{index + 1 < 10 ? `0${index + 1}` : index + 1}</th>
                                                                <td className="text-start">
                                                                    <span className="fw-medium">Mould Library
                                                                    </span>
                                                                    <p className="text-muted mb-0">Uploaded file: {job.file_name}</p>
                                                                      <p className="text-muted mb-0">Comment: {job.comment}</p>
                                                                </td>
                                                                <td> {job.materials_name}</td>
                                                              <td></td> 
                                                                <td>{job.qty}</td>
                                                                <td></td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5"></td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="border-top border-top-dashed mt-4" style={{ float: 'right' }}>
                                                <td colSpan="4"></td>
                                                <td colSpan="3" className="fw-medium p-0">
                                                    <table className="table table-borderless text-start table-nowrap align-middle mb-0" >
                                                        <tbody>
                                                            <tr>
                                                                <th scope="row" className="p-2 text-muted fs-5">Subtotal </th>
                                                                <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(Quotation.subtotal_summary)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row" className="p-2 text-muted fs-5">Discount Total </th>
                                                                <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(Quotation.discount_summary)}</td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row" className="p-2 text-muted fs-5">VAT Total  </th>
                                                                <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(Quotation.taxtotal_summary)}</td>
                                                            </tr>
                                                            <tr className="border-top border-top-dashed">
                                                                <th scope="row" className="p-2 text-muted fs-5">Total</th>
                                                                <td className="p-0 text-end fw-medium fs-5">{vAdminformat.FormatMoney(Quotation.total_summary)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*end card-body*/}
                                <div style={{ marginBlock: "100px" }}>
                                    <center><h5>Tracking</h5></center>
                                    <div className="position-relative" id="users-chat" style={{ overflow: "auto", border: '1px solid #80808069' }}>
                                        <div className="chat-conversation p-3 p-lg-4 " id="chat-conversation" data-simplebar >
                                            <ul className="list-unstyled chat-conversation-list" id="users-conversation">

                                                {trackingView.map((conv) => (

                                                    conv.via === 0 ? (

                                                        <li className="chat-list left">
                                                            <div className="chat-avatar">
                                                                <img src="assets/images/users/user-dummy-img.jpg" alt="dbc" />
                                                            </div>
                                                            <div className="conversation-list">
                                                                <div className="user-chat-content">
                                                                    <div className="ctext-wrap">
                                                                        <span className="card text-muted p-0">{conv.title}
                                                                            <div className="ctext-wrap-content">
                                                                                <p className="mb-0 ctext-content">{conv.comment}</p>
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                    <div className="conversation-name"><small className="text-muted time">{vAdminformat.FormatDate(conv.date_created)} | {conv.user_created}</small> <span className="text-success check-message-icon"><i className="ri-check-double-line align-bottom"></i></span></div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ) : (
                                                        conv.via === 1 ? (

                                                            <li className="chat-list right">
                                                                <div className="conversation-list">
                                                                    <div className="user-chat-content">
                                                                        <div className="ctext-wrap">
                                                                            <div className="ctext-wrap-content">
                                                                                <p className="p-0 m-0 text-muted ">{conv.title}</p>
                                                                                <h6 className="mb-0 ctext-content">{conv.comment}</h6>
                                                                            </div>
                                                                            <div className="dropdown align-self-start message-box-drop">
                                                                                <a className="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                    <i className="ri-more-2-fill"></i>
                                                                                </a>
                                                                                <div className="dropdown-menu">
                                                                                    <Link type="button" className="dropdown-item reply-message" onClick={() => {

                                                                                        setOnCommentID(conv)
                                                                                        showModifyCommentModal()

                                                                                    }}><i className="ri-pencil-fill fs-16"></i> Modify</Link>

                                                                                    <Link className="dropdown-item delete-item" onClick={() => DeletedCommentQuotation(conv.quott_ID, getCurrentQuot)}><i className="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>Delete</Link>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="conversation-name"><small className="text-muted time">{vAdminformat.FormatDate(conv.date_created)} | {conv.user_created}</small> <span className="text-success check-message-icon"><i className="ri-check-double-line align-bottom"></i></span></div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ) : null
                                                    )

                                                ))}

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                         

                        </div>

                    </div>

                    <div className={`modal fade ${sendEmail ? 'show' : ''}`}
                        style={{ display: sendEmail ? 'block' : 'none', backgroundColor: "#0000007a" }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content">
                           
                                <div className="modal-header">
                                    <h5 className="modal-title" id="modalLabel">Send Email</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => setSendEmail(false)}
                                    ></button>
                                </div>

                      
                                <div className="modal-body">

                                    <div className="mb-3">
                                        <label htmlFor="to-email" className="form-label">To</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="to-email"
                                            placeholder="Email"
                                            maxLength="256"
                                            value={formData.to}
                                            onChange={(e) => setFormData({ ...formData, to: e.target.value })}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="cc-email" className="form-label">CC</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="cc-email"
                                            maxLength="50"
                                            value={formData.cc}
                                            onChange={(e) => setFormData({ ...formData, cc: e.target.value })}
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={sendEmailBk}
                                    >
                                        Send Email
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            )}


            {/*end row*/}
            {isComment && (
                <AddComment QuotationID={QuotationID} onClose={CloseAddCommentModal} getQuotations={getCurrentQuot} />
            )}
            {isModifiyComment && (
                <ModifyComment QuotationID={QuotationID} onCommentID={onCommentID} onClose={CloseModifyCommentModal} getQuotations={getCurrentQuot} />
            )}
        </div>
    )
}


export default QuotationViews;